import { render, staticRenderFns } from "./BuildingUpgradeCadaster.vue?vue&type=template&id=7cf2ae67&"
import script from "./BuildingUpgradeCadaster.vue?vue&type=script&lang=js&"
export * from "./BuildingUpgradeCadaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports